<template>
  <header>
    <nav class="navbar navbar-inverse navbar-fixed-bottom" :class="bg">
      <div class="container-fluid">
        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="nav-menu">
          <ul class="nav navbar-nav">
            <img
              class="img-responsive"
              screen="big"
              src="@/assets/ss-logo.svg"
              alt="MENU"
            />

            <li v-for="(route, index) in routes" :key="index">
              <router-link v-show="route.level == level" :to="route.path">
                <!--<router-link v-show="!($route.path == route.path)" :to="route.path">-->
                {{ route.displayText }}
              </router-link>
            </li>

            <!--<li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">About</router-link></li>
              <li><router-link to="/education">Education</router-link></li>
              <li><router-link to="/skills">Skills</router-link></li>
              <li><router-link to="/gallery">Gallery</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>-->

            <img
              class="img-responsive"
              screen="big"
              src="@/assets/ss-logo.svg"
              alt="MENU"
            />
          </ul>
        </div>
        <!-- /.navbar-collapse -->

        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header d-flex align-items-center">
          <h3 class="visible-xs navbar-toggle">
            {{ $route.name ? $route.name.toUpperCase() : "" }}
          </h3>

          <!--class="navbar-toggle collapsed" -->
          <button
            ref="toggleNavMenuButton"
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#nav-menu"
          >
            <img
              class="img-responsive"
              screen="small"
              src="@/assets/ss-logo.svg"
              alt="MENU"
            />
          </button>
          <!--<router-link to="/" class="navbar-brand"><img src="@/assets/logo.png"></router-link>-->
        </div>
        <!-- /.navbat-header -->
      </div>
      <!-- /.container-fluid -->
    </nav>
  </header>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      routes: [
        { path: "/", displayText: "Home", level: "main" },
        { path: "/about", displayText: "About", level: "main" },
        //{ path: '/education', displayText: 'Education' },
        //{ path: '/skills', displayText: 'Skills' },
        { path: "/gallery", displayText: "Gallery", level: "main" },
        { path: "/contact", displayText: "Contact", level: "main" },

        { path: "/gallery", displayText: "Main menu", level: "sub" },
        { path: "/animation", displayText: "Animation", level: "sub" },
        { path: "/games", displayText: "Games", level: "sub" },
        { path: "/web-dev", displayText: "Web Dev", level: "sub" },
        { path: "/ar", displayText: "AR", level: "sub" },
        {
          path: "/video-photo",
          displayText: "Video/photo editing",
          level: "sub",
        },
        { path: "/embedded", displayText: "Embedded", level: "sub" },
      ],
      mainRoutesPaths: ["/", "/about", "/gallery", "/contact"],
      subroutesPaths: [
        "/animation",
        "/games",
        "/web-dev",
        "/ar",
        "/video-photo",
        "/embedded",
      ],
    };
  },
  methods: {},

  computed: {
    bg() {
      switch (this.$route.path) {
        case "/about":
          return "about-bg";
        case "/gallery":
          return "education-bg";
        //case '/skills': return 'skills-bg'
        case "/contact":
          return "contact-bg";

        case "/animation":
          return "animation-bg";
        case "/games":
          return "games-bg";
        case "/web-dev":
          return "web-dev-bg";
        case "/ar":
          return "ar-bg";
        case "/video-photo":
          return "video-photo-bg";
        case "/embedded":
          return "embedded-bg";

        default:
          return "";
      }
    },
    level() {
      const currentRoute = this.$route.path;
      //console.log('current route:', currentRoute);
      if (this.mainRoutesPaths.includes(currentRoute)) {
        return "main";
      } else {
        return "sub";
      }
    },
  },

  created() {},

  mounted() {
    //$('.navbar-nav>li>a').on('click', function(){
    //  $('.navbar-collapse').collapse('hide');
    //});

    //$(".navbar-collapse a").click(() => {
    //  $(".navbar-toggle").click();
    //});

    //$('#asd').click(); //this will make a click on the button

    //$("[aria-current='page']").addClass('hidden-xs');

    // Close Bootstrap 3 navbar when a nav item is clicked
    //source link: https://bootstrapcreative.com/close-navbar-nav-link-clicked/
    $(".navbar-collapse ul li a:not(.dropdown-toggle)").on(
      "click",
      function () {
        //'click touchstart'
        //if(!this.classList.contains('router-link-exact-active'))
        $(".navbar-toggle:visible").click();
        //$(this).addClass('hidden-xs');
        //this.classList.add('hidden-xs');
      }
    );
    /* This code is written in JavaScript using the jQuery library. 
    It's a script that adds a click or touch event handler to the anchor tags (<a>) 
    that are direct children of list items (<li>) and are not a part of a dropdown menu. 
    The handler function has the following functionality:

    When a click or touch event is triggered on one of these anchor tags, the function runs.
    The function uses the $('.navbar-toggle:visible') selector to get the first visible 
    .navbar-toggle element on the page. It then triggers a click event on this element using 
    the .click() method, causing the visible navigation bar to be toggled (hidden or shown).
    This code is typically used for responsive design in navigation menus. 
    The purpose of the script is to collapse the navigation menu when one of the links in 
    the menu is clicked or touched, so that the menu doesn't take up too much space on smaller screens. */
  },
};
</script>

<style scoped>
/*:root {
  --mobile-nav-color: rgb(171, 77, 77);
}*/
nav {
  background: black;
  z-index: 20 !important;
  text-align: right;
  /*transition: background-image 1s;*/

  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.about-bg {
  background: url("@/assets/about/nav-fire.jpg");
  background-size: cover;
  /*background-position: center;*/
  /*transition: background-image 1s;*/
}

.education-bg {
  background: url("@/assets/education/space-bg-2.jpg");
  background-position: center;
  background-size: cover;
}

.skills-bg {
  background: url("@/assets/skills/skills-bg.png");
  background-position: center;
  background-size: cover;
}

.contact-bg {
  background: url("@/assets/contact/paper.png");
  /*background-position: center;*/
  background-size: cover;
}

.animation-bg {
  background: navy;
}
.games-bg {
  background: rgb(46, 2, 2);
}
.ar-bg {
  background: var(--ar-primary-color);
}
.video-photo-bg {
  background: var(--video-photo-primary-color);
}
.embedded-bg {
  background: #ff8400;
}
.web-dev-bg {
  background: rgb(30, 29, 29);
}

nav a {
  font-size: 20px;
  font-weight: bold;
  /*color: #2c3e50;*/
  color: white !important;
  transition: box-shadow 0.3s;
  /*cursor: pointer;*/
}

.navbar {
  box-shadow: 0 -2px 5px white; /*royalblue*/
}

.navbar-header button {
  padding: 5px;
}

.navbar-header img {
  height: 40px;
}

/*#nav-menu {
  box-shadow: 0 -5px 10px teal;
}*/

nav a.router-link-exact-active {
  /*color: #42b983 !important;*/
  /*color:white !important;*/
  /*box-shadow: 0 0 10px white;*/
  background-color: #0000008b !important;
}

nav a:hover {
  /*background-color: #1c2936 !important;*/
  box-shadow: 0 0 10px white;
  z-index: 2;
}

.navbar-brand img {
  height: 39px;
  position: relative;
  top: -10px;
  display: inline-block;
}

button.navbar-toggle {
  /*border: 2px outset #1c2936;*/
  border: 2px outset white;
  border-radius: 10px;
}
button.navbar-toggle:hover {
  background: rgba(192, 192, 192, 0.297) !important;
}

button.navbar-toggle:focus {
  background: rgba(192, 192, 192, 0.297) !important;
}

h3.navbar-toggle {
  font-size: 20px;
  color: white;
  font-weight: bold;
  float: left;
  border: none;
  margin-left: 5px;
  margin-top: 15px;
}
h3.navbar-toggle:hover {
  background: none !important;
}

nav a.router-link-exact-active.navbar-brand {
  color: white !important;
}

ul img {
  display: none;
}

/*ul {
  margin-top: 0;
}*/

img[screen="big"] {
  margin-left: 30px;
  margin-right: 30px;
}

@media only screen and (min-width: 768px) {
  ul {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  ul img {
    display: none;
  }

  a {
    font-size: 14px !important;
  }
}

@media only screen and (min-width: 980px) {
  ul img {
    display: inline-block;
    margin: 5px;
    height: 40px;
  }

  a {
    font-size: 14px !important;
  }
}

@media only screen and (min-width: 1100px) {
  a {
    font-size: 18px !important;
  }
}

@media only screen and (min-width: 1200px) {
  a {
    font-size: 20px !important;
  }
}
</style>
